module.exports = __webpack_public_path__ + "static/img/wDHSOIZg.23afbd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/wDHSOIZg.jpg
// module id = c6v8
// module chunks = 7